import React from "react";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";
import InvoiceForm from "./InvoiceEntry";

const InvoiceEntryPage = () => {
  return (
    <NavHeightAdjust>
      <InvoiceForm />
    </NavHeightAdjust>
  );
};

export default InvoiceEntryPage;
